import { captureException, setContext, setTag } from '@sentry/react-native';
import {
  channel,
  createdAt,
  emergencyLaunchReason,
  isEmbeddedLaunch,
  isEmergencyLaunch,
  runtimeVersion,
  updateId,
} from 'expo-updates';
import { getAppUpdateType } from 'shared/utils/appUpdateInfo/appUpdateInfo';

import { EXPO_UPDATE_CONTEXT_KEY, SentryTags } from './sentry.constants';

// Tags every Sentry event with whether the running JS came from an OTA update or
// the embedded build, plus the update identity, so errors can be segmented
// OTA-vs-embedded and pinned to a specific updateId. A non-null updateId is the
// authoritative signal that an OTA bundle is running.
const setExpoUpdateContext = () => {
  try {
    setTag(SentryTags.EXPO_UPDATE_TYPE, getAppUpdateType());
    setTag(SentryTags.EXPO_UPDATE_ID, updateId ?? undefined);
    setTag(SentryTags.EXPO_CHANNEL, channel ?? undefined);
    setTag(SentryTags.EXPO_RUNTIME_VERSION, runtimeVersion ?? undefined);

    setContext(EXPO_UPDATE_CONTEXT_KEY, {
      updateId,
      channel,
      runtimeVersion,
      createdAt: createdAt?.toISOString() ?? null,
      isEmbeddedLaunch,
      isEmergencyLaunch,
      emergencyLaunchReason,
    });
  } catch (error) {
    captureException(error);
  }
};

export default setExpoUpdateContext;
